import { SelectorType } from "@/components/section/selectorButton";
import {
  LoyaltyAccount,
  LoyaltyProgramEnum,
} from "@/generated/email_parser.openapi";

export const brandTypeImages = [
  {
    brandType: "hotel",
    image: "/assets/hotel.svg",
    name: SelectorType.HOTEL,
  },
  {
    brandType: "airline",
    image: "/assets/icons/airplane.svg",
    name: SelectorType.AIRLINE,
  },
  {
    brandType: "card",
    image: "/assets/icons/credit-card.svg",
    name: SelectorType.CARD,
  },
  {
    brandType: "rental_car",
    image: "/assets/icons/car.svg",
    name: SelectorType.RENTAL_CAR,
  },
];

export const getBrandTypeImage = (brandType: string) =>
  brandTypeImages.find((brand) => brand.brandType === brandType)?.image ?? "";

export const getBrandTypeName = (brandType: string) =>
  brandTypeImages.find((brand) => brand.brandType === brandType)?.name ??
  SelectorType.HOTEL;

export const filterLoyaltyAccounts = (a: LoyaltyAccount) => {
  const isAccountActive = Boolean(
    a.loyaltyId || a.loyaltyStatus || a.loyaltyPoints !== undefined
  );
  return !a.deletedAt && (isAccountActive || a.parseInProgress);
};

export const loadingBgs = "animate-pulse rounded bg-muted";

export const needToResyncOnNotConnected = (loyaltyAccount: LoyaltyAccount) =>
  loyaltyAccount.mxRewards?.some(
    (mxReward) =>
      loyaltyAccount.brandType === "card" &&
      mxReward.connectionStatus !== "CONNECTED" &&
      mxReward.connectionStatus !== undefined
  ) && loyaltyAccount.loyaltyProgram !== LoyaltyProgramEnum.BiltRewards;

export const filterActiveLoyaltyAccounts = (
  loyaltyAccounts: LoyaltyAccount
): boolean => {
  const isAccountActive = Boolean(
    loyaltyAccounts
      ? loyaltyAccounts.loyaltyId ||
          loyaltyAccounts.loyaltyStatus ||
          loyaltyAccounts.loyaltyPoints !== undefined
      : false
  );

  return Boolean(isAccountActive || loyaltyAccounts.parseInProgress);
};

export const isDeletedLoyaltyAccount = (
  loyaltyAccount: LoyaltyAccount
): boolean => {
  return (
    loyaltyAccount.deletedAt !== undefined && loyaltyAccount.deletedAt !== null
  );
};
export const isMissingCoreData = (loyaltyAccount: LoyaltyAccount) => {
  const isCreditCard = loyaltyAccount.brandType === "card";
  let missingCoreData: boolean;
  if (isCreditCard) {
    missingCoreData = Boolean(loyaltyAccount.loyaltyPoints === undefined);
  } else {
    missingCoreData = Boolean(
      !loyaltyAccount.loyaltyId ||
        !loyaltyAccount.loyaltyStatus ||
        loyaltyAccount.loyaltyPoints === undefined
    );
  }
  return missingCoreData;
};
